import TYPE from '../actions/TYPE';

const initialState = {
  detect: [],
  list: []
};

const category = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.GET_CATEGORY_DETECT_SUCCESS:
      return {
        ...state,
        detect: [...state.detect].concat(action.payload)
      };
    case TYPE.GET_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
};

export default category;
